import { render, staticRenderFns } from "./SidenavBlock.vue?vue&type=template&id=781fc20d&"
import script from "./SidenavBlock.vue?vue&type=script&lang=js&"
export * from "./SidenavBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/code/nathan/Sonido_SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('781fc20d')) {
      api.createRecord('781fc20d', component.options)
    } else {
      api.reload('781fc20d', component.options)
    }
    module.hot.accept("./SidenavBlock.vue?vue&type=template&id=781fc20d&", function () {
      api.rerender('781fc20d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/src/vendor/libs/sidenav/SidenavBlock.vue"
export default component.exports